import { images } from "../assets/img";

export const NAIL_SHOP_INFO = {
  ggMapUrl: "https://maps.app.goo.gl/FMpC5xDnsJSqcnpJ7",
  address: "73 Parkway, London NW1 7PP, United Kingdom",
  ggMapIframeUrl:"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2481.680587612823!2d-0.14524420000000002!3d51.5374181!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48761b25dd05933f%3A0xecf56baf84ff775d!2sCamden%20Nails%20%26%20Beauty!5e0!3m2!1sen!2s!4v1723741405990!5m2!1sen!2s",
  email: "info@camdennailsnbeauty.co.uk",
  tel: "+4402072843366",
  phone: "+44 020 7284 3366",
  facebookId:"100067203955272",
  instagramName: "camdennailsandbeauty",
  name: "Camden Nails & Beauty",
  bookingUrl: "https://camdennails.square.site",
  openingTime:{
    openTime:{weekdays: "MONDAY - SATURDAY", time:"10:00 - 19:00"},
    closeTime:{weekdays: "SUNDAY", time:"11:00 - 18:00"}
  },
};

NAIL_SHOP_INFO.instagram = `https://www.instagram.com/${NAIL_SHOP_INFO.instagramName}`;
NAIL_SHOP_INFO.instagramChatUrl = `https://ig.me/m/${NAIL_SHOP_INFO.instagramName}`;
NAIL_SHOP_INFO.facebook = `https://www.facebook.com/profile.php?id=${NAIL_SHOP_INFO.facebookId}`
NAIL_SHOP_INFO.facebookMessengerUrl = `http://m.me/${NAIL_SHOP_INFO.facebookId}`

export const SOLCO_INFO = {
  facebook: "https://www.facebook.com/solcoagency.marketing",
  website: "https://solcomarketing.com",

  huaCatLuongWebsite: "https://huacatluong.com",
};

export const SERVICES = [
  {
    name: "Manicures",
    description:
      "Experience a manicure that focuses on precision and care, using premium products to enhance the natural beauty of your nails. Our expert technicians ensure that your nails are treated with the utmost attention and ready to impress.",

    image: images.nailService,
  },
  {
    name: "Pedicures",
    description:
      "Indulge in a pedicure that shapes, smooths, and cares for your nails and toes. Enjoy exfoliation with a refreshing cucumber or peppermint mask, followed by a soothing cream application, and finish with the perfect color of your choice.",
    image: images.nailService2,
  },
  {
    name: "Our Technicians",
    description:
      "Our highly qualified team of nail technicians will take care your nails the ins and outs during your experiences at our nails bar. We always welcome you with a warm smile and make you feel at home.",
    image: images.nailService3,
  },
  {
    name: "Nails Art",
    description:
      "From classic to outstanding, our talented technicians can advise you the bespoke nail art of your imagine. Come here and enjoy your amazing nails art at our local shop",
    image: images.nailService4,
  },
];

export const LANGUAGE_ID = {
  vi: "vi",
  en: "en",
};

export const CUSTOMER_FEEDBACK = [
  {
    name: "Loren Stutts",
    feedback:
      "Ã¢â‚¬Å“Love the team here, particularly once they were acquired by new management about 2-ish years ago. My nails are always exactly what I ask for, they have an expansive colour selection, comfy chairs for pedicures - the vibey music is always a nice bonus. Would suggest to book in advance though as theyÃ¢â‚¬â„¢re good, so are usually busy!Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/sU1i6Sk.png",
  },
  {
    name: "shazia lynch",
    feedback:
      "Ã¢â‚¬Å“I really enjoyed my experience. I got a Ã¢â€šÂ¬35 Groupon deal and came out with pretty nails. Thank you. Such a lovely team, clean place Ã°Å¸â€™â€”Ã°Å¸â€™â€”Ã°Å¸â€™â€”Ã°Å¸â€™â€”Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/Lq7YQ1o.png",
  },
  {
    name: "Miriam Deas",
    feedback:
      "Ã¢â‚¬Å“Really lovely friendly staff and one of the best manicures IÃ¢â‚¬â„¢ve had. Attention to detail and good advise too for next time. Highly recommend!Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/HDBW1Xg.png",
  },
  {
    name: "Laura Geere",
    feedback:
      "Ã¢â‚¬Å“Love this place been coming here for over a year now. never had a bad set all the staff is wonderful and friendly. Every time me and my best mate come in they are fabulousÃ¢â‚¬Â",
    avatar: "https://i.imgur.com/RsFFmiS.png",
  },
  {
    name: "Cocokaitlyn",
    feedback:
      "Ã¢â‚¬Å“Got my nice nail color. Would definitely recommend this salon to every girls out there.Really pleased to have this new salon in the local area. Clean, spacious salon, good value and a nice manicure that has lasted well. A great experience which I definetely would recommend. The staff is welcoming.I will be going back.Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/Ds2X7zK.png",
  },
  {
    name: "Isabella White",
    feedback:
      "Ã¢â‚¬Å“I booked a last-minute appointment, and they exceeded my expectations. My gel manicure has been flawless for weeks!Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/KxhUFKM.jpg",
  },
  {
    name: "Scarlett Brown",
    feedback:
      "Ã¢â‚¬Å“Very professional service. My nails always look stunning and they cater to any design you like. The staff are all super friendly and I wouldn't go to any other salon Ã¢ÂÂ¤Ã¯Â¸Â. Make sure you book an appointment as they are usually quite busy!Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/kI3rsKc.jpg",
  },
  {
    name: "Ella Wilson",
    feedback:
      "Ã¢â‚¬Å“Really great quality work! IÃ¢â‚¬â„¢ve been to much more expensive places in central London, but they do a much better job here Ã°Å¸â€™Å“ they take care, have great attention to detail, and they let me check that I like the shape and am happy with how things look at every stage which I really appreciate as IÃ¢â‚¬â„¢m a bit of a perfectionist! Highly recommend Trang Ã°Å¸â€™Å“Ã°Å¸â€™Å“Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/92gXkP8.jpg",
  },
];

export const MENU_HEADER = [
  { name: "Home", navigationKey: "home" },
  { name: "About Us", navigationKey: "about-us" },
  { name: "Services", navigationKey: "services" },
  { name: "Booking", navigationKey: NAIL_SHOP_INFO.bookingUrl },
  // { name: "Contacts", navigationKey: "contactsRef" },
  { name: "Contact", navigationKey: "contact-us" },
  { name: "Policy", navigationKey: "policy" },
];
